import React from "react";
import { STATUS_BADGE } from "./constants";

const StatusBadge = ({ status }) => {
  const config = STATUS_BADGE[status] || { label: status || "—", classes: "bg-gray-50 text-gray-700 border-gray-200" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-tight border ${config.classes}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
